export { default } from "./ConfigureCPElement"